import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { applyFilters } from "../../store/rankings.actions"
import { getActiveFilters } from "../../store/rankings.selectors"
import { AwardsIndustryFilterBox } from "../../styles"
import SelectInput from "../filters/selectInput"
import { getAllIndustries } from "../../../misc/store/misc.selectors"

const AwardsIndustryFilter = () => {
  const dispatch = useDispatch()
  const appliedFilters = useSelector(getActiveFilters)
  const filters = useSelector(getAllIndustries)

  const handleSubmit = e => {
    dispatch(applyFilters({ industry: e }))
  }

  return (
    <AwardsIndustryFilterBox>
      <SelectInput
        options={{
          id: "filter-industry",
          label: "Industry",
          items: filters || []
        }}
        isLoading={filters?.isLoading}
        filterValue={appliedFilters.industry}
        onFilter={handleSubmit}
      />
    </AwardsIndustryFilterBox>
  )
}

export default AwardsIndustryFilter
